<template>
  <div class="customers">
    <Loading v-if="loading" />
    <div class="customers__chooseDate">
      <div class="customers__chooseDate__container">
        <div class="chooseDate-date-inputs">
          <div class="input">
            <Calendar
              type="datetime"
              format="DD/MM/YYYY HH:mm"
              :value="firstDay"
              name="startTime"
              :minute-step="selectedInterval"
              :hour-options="hourInterval"
              @change="changeDate"
            />
          </div>
          <img class="date-img" src="@/assets/icons/Hyphen.svg" alt="Hyphen" />
          <div class="input">
            <Calendar
              type="datetime"
              format="DD/MM/YYYY HH:mm"
              :value="today"
              name="endTime"
              @change="changeDate"
            />
          </div>
        </div>
      </div>
      <p v-if="!isDateCorrect" class="date-error">{{ $t('errorDate') }}</p>
    </div>
    <div class="customers__container">
      <div class="customers__checkboxes">
        <template v-for="(checkbox, index) in checkboxes" :key="index">
          <Checkbox
            class="customers-checkbox"
            :name="checkbox.name"
            :value="checkbox.value"
            :title="$t(checkbox.title)"
            @change="toggleCheckbox(checkbox.name)"
          />
        </template>
      </div>
      <div class="customers__option-dropdowns">
        <div class="option-dropdowns">
          <Dropdown
            :class="{
              'customers-dropdown': true,
              'customers-dropdown-disabled': !checkboxes[1].value
            }"
            :selected-option="getOptionFace.selectedOption"
            :options="getOptionFace.options"
            :multiple="true"
            :disabled="!checkboxes[1].value"
            @select-option="selectOptionFace"
          />
          <Dropdown
            :class="{
              'customers-dropdown': true,
              'customers-dropdown-disabled': !checkboxes[1].value
            }"
            :selected-option="getOptionType.selectedOption"
            :options="getOptionType.options"
            :multiple="true"
            :disabled="!checkboxes[1].value"
            @select-option="selectOptionType"
          />
        </div>
        <!-- <div class="grade-dropdowns">
          <Dropdown
            :class="{
              'customers-dropdown': true,
              'customers-dropdown-disabled': !checkboxes[3].value
            }"
            :selected-option="getOptionGrade.selectedOption"
            :options="getOptionGrade.options"
            :disabled="!checkboxes[3].value"
            @select-option="selectOptionGrade"
          />
          <Dropdown
            :class="{
              'customers-dropdown': true,
              'customers-dropdown-disabled':
                !checkboxes[3].value ||
                getOptionGrade.selectedOption.label === 'Grade'
            }"
            :selected-option="getGradeType.selectedOption"
            :options="getGradeType.options"
            :disabled="
              !checkboxes[3].value ||
              getOptionGrade.selectedOption.label === 'Grade'
            "
            @select-option="selectGradeType"
          />
        </div> -->
      </div>
    </div>
    <Table
      v-if="filteredFeedback.length"
      :data="filteredFeedback"
      :columns="columns"
      @load-more="changePage"
    />
    <div v-if="!filteredFeedback.length && !loading" class="customers__noData">
      <p>{{ $t('noData') }}</p>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import {
  getDatabase,
  ref,
  query,
  orderByChild,
  startAt,
  endAt,
  limitToFirst,
  get
} from 'firebase/database';

import Loading from '@/views/Loading.vue';

import {
  checkboxes as initialCheckboxes,
  activeOptionsFace,
  // activeOptionsGrade,
  // activeOptionsGradeType,
  columns
} from './configs';

import { Checkbox, InputFileEvent, Option } from '@/types';
import { FeedbackItem, FeedbackItemData } from '@/store/modules/pharmacy/types';

@Options({
  name: 'Customers',
  props: ['pharmacy'],
  components: {
    Loading
  },
  data() {
    return {
      loading: false,
      params: {
        startTime: new Date().setHours(0, 0, 0, 0).valueOf(),
        endTime: new Date().getTime()
      },
      selectedInterval: 5,
      hourInterval: 0,
      selectedTemplatesString: '',
      checkboxes: JSON.parse(JSON.stringify(initialCheckboxes)),
      getOptionFace: {
        selectedOption: {
          label: this.$t('face')
        },
        options: activeOptionsFace(this.$t)
      },
      getOptionType: {
        selectedOption: {
          label: this.$t('type')
        },
        options: []
      },
      // getOptionGrade: {
      //   selectedOption: {
      //     label: this.$t('grade')
      //   },
      //   options: activeOptionsGrade
      // },
      // getGradeType: {
      //   selectedOption: {
      //     label: this.$t('type')
      //   },
      //   options: activeOptionsGradeType(this.$t)
      // },
      columns: columns(this.$t),
      feedback: [],
      filteredFeedback: [] as FeedbackItem[],
      lastTimestamp: null
    };
  },
  created() {
    if (this.pharmacy) {
      this.pharmacyId = this.pharmacy.id;

      this.show();
    }
  },
  computed: {
    today() {
      const todayDate = new Date().getTime();

      return todayDate;
    },
    firstDay(): number {
      const firstDate = new Date().setHours(0, 0, 0, 0).valueOf();

      return firstDate;
    },
    isDateCorrect() {
      if (this.params && this.params.startTime && this.params.endTime) {
        return this.params.endTime >= this.params.startTime;
      }
      return true;
    }
  },
  beforeUnmount() {
    if (this.checkboxes && Array.isArray(this.checkboxes)) {
      this.checkboxes.forEach((checkbox: Checkbox) => {
        checkbox.value = false;
      });
    }
  },
  methods: {
    show() {
      this.initOptionTemplatesCharts();
      this.fetchFeedback(true);
    },
    async fetchFeedback(reset = false) {
      const database = getDatabase();
      const pharmacyId = this.pharmacy.id;
      const baseUrl = `/feedback/${pharmacyId}`;

      if (reset) {
        this.feedback = [];
        this.filteredFeedback = [];
        this.lastTimestamp = null;
      }

      const fetchData = async (startTime: number | null) => {
        const dbRef = ref(database, baseUrl);
        const queryRef = query(
          dbRef,
          orderByChild('timestamp'),
          startAt(startTime),
          endAt(this.params.endTime),
          limitToFirst(50 - this.feedback.length)
        );

        try {
          const snapshot = await get(queryRef);
          const result = snapshot.val();

          if (!result) return [];

          const newFeedbackRaw = Object.values(result) as FeedbackItem[];

          const newFeedback = newFeedbackRaw.filter((item) => {
            if (item.report) return true;
            if (!Array.isArray(item.data)) return false;

            return item.data.some(
              (el) => el && typeof el === 'object' && 'grade' in el
            );
          });

          this.feedback = this.feedback.concat(newFeedback);

          if (newFeedback.length > 0) {
            const maxTimestamp = Math.max(
              ...newFeedback.map((f) =>
                typeof f.timestamp === 'number' ? f.timestamp : 0
              )
            );
            this.lastTimestamp = maxTimestamp + 1;
          }

          return newFeedback;
        } catch (error) {
          console.error('Error fetching feedback:', error);
          return [];
        }
      };

      this.loading = true;

      let batch = await fetchData(this.params.startTime);

      if (batch.length === 0) {
        this.filterFeedback();
        this.loading = false;
        return;
      }

      while (this.feedback.length < 50 && batch.length > 0) {
        batch = await fetchData(this.lastTimestamp);

        if (batch.length === 0) break;
      }

      this.filterFeedback();
      this.loading = false;
    },
    async changePage() {
      if (this.loading) return;
      this.loading = true;

      const database = getDatabase();
      const pharmacyId = this.pharmacy.id;
      const baseUrl = `/feedback/${pharmacyId}`;
      const dbRef = ref(database, baseUrl);

      const queryRef = query(
        dbRef,
        orderByChild('timestamp'),
        startAt(this.lastTimestamp),
        endAt(this.params.endTime),
        limitToFirst(50)
      );

      try {
        const snapshot = await get(queryRef);
        const result = snapshot.val();

        if (result) {
          const newFeedbackRaw = Object.values(result) as FeedbackItem[];

          const newFeedback = newFeedbackRaw.filter((item) => {
            if (item.report) return true;
            if (!Array.isArray(item.data)) return false;

            return item.data.some(
              (el) => el && typeof el === 'object' && 'grade' in el
            );
          });

          this.feedback = this.feedback.concat(newFeedback);

          if (newFeedback.length > 0) {
            const maxTimestamp = Math.max(
              ...newFeedback.map((f) =>
                typeof f.timestamp === 'number' ? f.timestamp : 0
              )
            );
            this.lastTimestamp = maxTimestamp + 1;
          }
        }
      } catch (error) {
        console.error('Error fetching feedback:', error);
      }

      this.filterFeedback();

      this.loading = false;
      return this.feedback;
    },
    toggleCheckbox(name: string) {
      const checkbox = this.checkboxes.find((c: Checkbox) => c.name === name);

      if (checkbox) {
        checkbox.value = !checkbox.value;
        this.filterFeedback();
      }
    },
    filterFeedback() {
      this.loading = true;
      this.filteredFeedback = this.feedback.filter((item: FeedbackItem) => {
        const activeCheckboxes = this.checkboxes.filter(
          (cb: Checkbox) => cb.value
        );

        if (activeCheckboxes.length === 0) return true;

        return activeCheckboxes.every((checkbox: Checkbox) => {
          switch (checkbox.name) {
            // case 'showOnlyWithContact':
            //   if (!item.contact) return false;
            //   break;
            case 'showOnlyWithReport':
              if (!item.report) return false;
              break;
            case 'showOnlyWithOption':
              if (
                this.getOptionFace.selectedOption.length > 0 ||
                this.getOptionType.selectedOption.length > 0
              ) {
                const faces = Array.isArray(this.getOptionFace.selectedOption)
                  ? this.getOptionFace.selectedOption.map(
                      (opt: Option) => opt.value
                    )
                  : [];
                const types = Array.isArray(this.getOptionType.selectedOption)
                  ? this.getOptionType.selectedOption.map(
                      (opt: Option) => opt.value
                    )
                  : [];

                const dataArray: FeedbackItemData[] = Array.isArray(item.data)
                  ? (item.data as FeedbackItemData[])
                  : item.data
                  ? (Object.values(item.data) as FeedbackItemData[])
                  : [];

                const dataItemsMatch = dataArray.some(
                  (dataItem: FeedbackItemData) => {
                    return (
                      (faces.length === 0 || faces.includes(dataItem.grade)) &&
                      (types.length === 0 || types.includes(dataItem.type))
                    );
                  }
                );

                if (!dataItemsMatch) return false;
              }
              break;
            // case 'showOnlyWithGrade':
            //   if (
            //     this.getOptionGrade.selectedOption?.label !==
            //       this.$t('grade') &&
            //     this.getGradeType.selectedOption?.label !== this.$t('type')
            //   ) {
            //     const grade: number | undefined = item.grade?.grade;
            //     const selectedGrade = parseFloat(
            //       this.getOptionGrade.selectedOption.value
            //     );

            //     if (grade === undefined) return false;

            //     if (this.getGradeType.selectedOption.value === 'higher') {
            //       if (!(grade > selectedGrade)) return false;
            //     } else if (this.getGradeType.selectedOption.value === 'lower') {
            //       if (!(grade < selectedGrade)) return false;
            //     } else if (this.getGradeType.selectedOption.value === 'same') {
            //       if (!(grade === selectedGrade)) return false;
            //     }
            //   }
            //   break;
            default:
              break;
          }
          return true;
        });
      });

      this.filteredFeedback.sort(
        (a: FeedbackItem, b: FeedbackItem) => b.timestamp - a.timestamp
      );
      this.loading = false;
    },
    changeDate(e: InputFileEvent) {
      const { name, value } = e.target;
      this.params = { ...this.params, [name]: value };
    },
    selectOptionFace(option: Option) {
      this.getOptionFace.selectedOption = option;
      this.filterFeedback();
    },
    selectOptionType(option: Option[]) {
      this.getOptionType.selectedOption = option;
      this.filterFeedback();
    },
    // selectOptionGrade(option: Option) {
    //   this.getOptionGrade.selectedOption = option;
    //   if (option.label !== this.$t('grade')) {
    //     this.getGradeType.options = activeOptionsGradeType(this.$t);
    //   } else {
    //     this.getGradeType.selectedOption = { label: this.$t('type') };
    //     this.getGradeType.options = [];
    //   }
    //   this.filterFeedback();
    // },
    // selectGradeType(option: Option) {
    //   this.getGradeType.selectedOption = option;
    //   this.filterFeedback();
    // },
    initOptionTemplatesCharts() {
      const options = this.pharmacy.feedbackTemplate.options_screen.options;
      const language = this.user?.appLanguage;

      this.getOptionType.options = Object.keys(options).map((key: string) => {
        const translations = options[key]?.translations;

        if (translations && translations[language]) {
          return { value: key, label: translations[language] };
        } else {
          return { value: key, label: translations['en'] };
        }
      });
    }
  },
  watch: {
    checkboxes: {
      deep: true,
      handler() {
        if (!this.checkboxes[1].value) {
          this.getOptionFace.selectedOption = {
            label: this.$t('face')
          };

          this.getOptionType.selectedOption = {
            label: this.$t('type')
          };
        }

        // if (!this.checkboxes[3].value) {
        //   this.getOptionGrade.selectedOption = {
        //     label: this.$t('grade')
        //   };

        //   this.getGradeType.selectedOption = {
        //     label: this.$t('type')
        //   };
        // }
      }
    },
    params: {
      deep: true,
      handler(newParams) {
        if (newParams.startTime !== null && newParams.endTime !== null) {
          this.show();
        }
      }
    },
    pharmacy() {
      if (this.pharmacy) {
        this.initOptionTemplatesCharts();
      }
    }
  }
})
export default class Customers extends Vue {}
</script>

<style lang="scss">
.customers {
  margin: 24px;
  .customers__chooseDate {
    margin-bottom: 32px;
    .customers__chooseDate__container {
      display: flex;
      align-content: center;
      justify-content: space-between;
      .chooseDate-date-inputs {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .formkit-outer {
          height: 42px;
          margin-bottom: 0 !important;
          .formkit-wrapper {
            height: 42px;
            .formkit-inner {
              height: 42px;
            }
          }
        }
        .input {
          position: relative;
          margin-bottom: 0;

          z-index: 2;
          .input-img {
            position: absolute;
            top: 12px;
            right: 12px;
            z-index: 0;
          }
        }
        .date-img {
          margin: 0 8px;
        }
      }
    }
    .date-error {
      color: $red;
      font-size: $fourteenSize;
      margin-top: 10px;
    }
  }
  .customers__container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .customers__checkboxes {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      width: 500px;
      .customers-checkbox {
        width: 194px;
        margin-bottom: 13px;
        margin-top: 13px;
      }
    }
    .customers__option-dropdowns {
      .option-dropdowns,
      .grade-dropdowns {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 420px;
        .customers-dropdown {
          height: 30px;
          width: 200px;
          &.customers-dropdown-disabled {
            .dropdown__head {
              background-color: $timePicker;
              cursor: auto;
              .dropdown__head-content-input {
                background-color: $timePicker;
                cursor: auto;
              }
              .dropdown__head-img {
                background-color: $timePicker;
              }
            }
          }
        }
        // &:first-child {
        //   margin-bottom: 12px;
        // }
      }
    }
  }
  .customers__noData {
    margin-top: 24px;
  }
}
</style>
